import Vue from "vue"
import Vuex from "vuex"
import { db } from "./firebaseDb";
Vue.use(Vuex)

// create another store called locations and import data from locations.json
const locations = new Vuex.Store({
  state: {
    locations: []
  },
  mutations: {
    SET_LOCATIONS (state, data) {
      state.locations = data
    }
  },
  getters: {
    locations (state) {
      return state.locations
    }
  }
})

let locationsData = []
      // get anlagen from firebase collection anlagen and save them in this.anlagen
      const ref = db.collection("anlagen");
      ref.onSnapshot((qs) => {
        locationsData = [];
        qs.forEach((doc) => {
          let anlage = doc.data();
          anlage.key = doc.data().locationId;
          locationsData.push(anlage);
        });
      });


locations.commit('SET_LOCATIONS', locationsData)
// show locations in console
//console.log('Loaded locations:', locations.getters.locations)
// import locations from "../../../../locationStore";
// locations.getters.locations.locations[0]['key']
export default locations;
